export function setPurchasesData(state, purchasesData) {
  state.purchasesData = purchasesData;
}